var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoUploadBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 398,
    height: 186,
    viewBox: "0 0 398 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4628 1.05682H1.05851V26.4205H26.4628V1.05682ZM0 0V27.4773H27.5213V0H0Z",
    fill: "url(#paint0_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9255 1.05682H27.5213V26.4205H52.9255V1.05682ZM26.4628 0V27.4773H53.984V0H26.4628Z",
    fill: "url(#paint1_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3883 1.05682H53.984V26.4205H79.3883V1.05682ZM52.9255 0V27.4773H80.4468V0H52.9255Z",
    fill: "url(#paint2_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.851 1.05682H80.4468V26.4205H105.851V1.05682ZM79.3883 0V27.4773H106.91V0H79.3883Z",
    fill: "url(#paint3_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.314 1.05682H106.91V26.4205H132.314V1.05682ZM105.851 0V27.4773H133.372V0H105.851Z",
    fill: "url(#paint4_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.777 1.05682H133.372V26.4205H158.777V1.05682ZM132.314 0V27.4773H159.835V0H132.314Z",
    fill: "url(#paint5_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.239 1.05682H159.835V26.4205H185.239V1.05682ZM158.777 0V27.4773H186.298V0H158.777Z",
    fill: "url(#paint6_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.702 1.05682H186.298V26.4205H211.702V1.05682ZM185.239 0V27.4773H212.761V0H185.239Z",
    fill: "url(#paint7_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.165 1.05682H212.761V26.4205H238.165V1.05682ZM211.702 0V27.4773H239.223V0H211.702Z",
    fill: "url(#paint8_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.628 1.05682H239.223V26.4205H264.628V1.05682ZM238.165 0V27.4773H265.686V0H238.165Z",
    fill: "url(#paint9_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.09 1.05682H265.686V26.4205H291.09V1.05682ZM264.628 0V27.4773H292.149V0H264.628Z",
    fill: "url(#paint10_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.553 1.05682H292.149V26.4205H317.553V1.05682ZM291.09 0V27.4773H318.612V0H291.09Z",
    fill: "url(#paint11_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.016 1.05682H318.612V26.4205H344.016V1.05682ZM317.553 0V27.4773H345.074V0H317.553Z",
    fill: "url(#paint12_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.479 1.05682H345.074V26.4205H370.479V1.05682ZM344.016 0V27.4773H371.537V0H344.016Z",
    fill: "url(#paint13_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.941 1.05682H371.537V26.4205H396.941V1.05682ZM370.479 0V27.4773H398V0H370.479Z",
    fill: "url(#paint14_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4628 27.4773H1.05851V52.8409H26.4628V27.4773ZM0 26.4205V53.8977H27.5213V26.4205H0Z",
    fill: "url(#paint15_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9255 27.4773H27.5213V52.8409H52.9255V27.4773ZM26.4628 26.4205V53.8977H53.984V26.4205H26.4628Z",
    fill: "url(#paint16_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3883 27.4773H53.984V52.8409H79.3883V27.4773ZM52.9255 26.4205V53.8977H80.4468V26.4205H52.9255Z",
    fill: "url(#paint17_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.851 27.4773H80.4468V52.8409H105.851V27.4773ZM79.3883 26.4205V53.8977H106.91V26.4205H79.3883Z",
    fill: "url(#paint18_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.314 27.4773H106.91V52.8409H132.314V27.4773ZM105.851 26.4205V53.8977H133.372V26.4205H105.851Z",
    fill: "url(#paint19_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.777 27.4773H133.372V52.8409H158.777V27.4773ZM132.314 26.4205V53.8977H159.835V26.4205H132.314Z",
    fill: "url(#paint20_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.239 27.4773H159.835V52.8409H185.239V27.4773ZM158.777 26.4205V53.8977H186.298V26.4205H158.777Z",
    fill: "url(#paint21_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.702 27.4773H186.298V52.8409H211.702V27.4773ZM185.239 26.4205V53.8977H212.761V26.4205H185.239Z",
    fill: "url(#paint22_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.165 27.4773H212.761V52.8409H238.165V27.4773ZM211.702 26.4205V53.8977H239.223V26.4205H211.702Z",
    fill: "url(#paint23_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.628 27.4773H239.223V52.8409H264.628V27.4773ZM238.165 26.4205V53.8977H265.686V26.4205H238.165Z",
    fill: "url(#paint24_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.09 27.4773H265.686V52.8409H291.09V27.4773ZM264.628 26.4205V53.8977H292.149V26.4205H264.628Z",
    fill: "url(#paint25_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.553 27.4773H292.149V52.8409H317.553V27.4773ZM291.09 26.4205V53.8977H318.612V26.4205H291.09Z",
    fill: "url(#paint26_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.016 27.4773H318.612V52.8409H344.016V27.4773ZM317.553 26.4205V53.8977H345.074V26.4205H317.553Z",
    fill: "url(#paint27_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.479 27.4773H345.074V52.8409H370.479V27.4773ZM344.016 26.4205V53.8977H371.537V26.4205H344.016Z",
    fill: "url(#paint28_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.941 27.4773H371.537V52.8409H396.941V27.4773ZM370.479 26.4205V53.8977H398V26.4205H370.479Z",
    fill: "url(#paint29_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4628 53.8977H1.05851V79.2614H26.4628V53.8977ZM0 52.8409V80.3182H27.5213V52.8409H0Z",
    fill: "url(#paint30_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9255 53.8977H27.5213V79.2614H52.9255V53.8977ZM26.4628 52.8409V80.3182H53.984V52.8409H26.4628Z",
    fill: "url(#paint31_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3883 53.8977H53.984V79.2614H79.3883V53.8977ZM52.9255 52.8409V80.3182H80.4468V52.8409H52.9255Z",
    fill: "url(#paint32_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.851 53.8977H80.4468V79.2614H105.851V53.8977ZM79.3883 52.8409V80.3182H106.91V52.8409H79.3883Z",
    fill: "url(#paint33_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.314 53.8977H106.91V79.2614H132.314V53.8977ZM105.851 52.8409V80.3182H133.372V52.8409H105.851Z",
    fill: "url(#paint34_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.777 53.8977H133.372V79.2614H158.777V53.8977ZM132.314 52.8409V80.3182H159.835V52.8409H132.314Z",
    fill: "url(#paint35_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.239 53.8977H159.835V79.2614H185.239V53.8977ZM158.777 52.8409V80.3182H186.298V52.8409H158.777Z",
    fill: "url(#paint36_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.702 53.8977H186.298V79.2614H211.702V53.8977ZM185.239 52.8409V80.3182H212.761V52.8409H185.239Z",
    fill: "url(#paint37_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.165 53.8977H212.761V79.2614H238.165V53.8977ZM211.702 52.8409V80.3182H239.223V52.8409H211.702Z",
    fill: "url(#paint38_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.628 53.8977H239.223V79.2614H264.628V53.8977ZM238.165 52.8409V80.3182H265.686V52.8409H238.165Z",
    fill: "url(#paint39_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.09 53.8977H265.686V79.2614H291.09V53.8977ZM264.628 52.8409V80.3182H292.149V52.8409H264.628Z",
    fill: "url(#paint40_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.553 53.8977H292.149V79.2614H317.553V53.8977ZM291.09 52.8409V80.3182H318.612V52.8409H291.09Z",
    fill: "url(#paint41_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.016 53.8977H318.612V79.2614H344.016V53.8977ZM317.553 52.8409V80.3182H345.074V52.8409H317.553Z",
    fill: "url(#paint42_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.479 53.8977H345.074V79.2614H370.479V53.8977ZM344.016 52.8409V80.3182H371.537V52.8409H344.016Z",
    fill: "url(#paint43_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.941 53.8977H371.537V79.2614H396.941V53.8977ZM370.479 52.8409V80.3182H398V52.8409H370.479Z",
    fill: "url(#paint44_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4628 80.3182H1.05851V105.682H26.4628V80.3182ZM0 79.2614V106.739H27.5213V79.2614H0Z",
    fill: "url(#paint45_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9255 80.3182H27.5213V105.682H52.9255V80.3182ZM26.4628 79.2614V106.739H53.984V79.2614H26.4628Z",
    fill: "url(#paint46_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3883 80.3182H53.984V105.682H79.3883V80.3182ZM52.9255 79.2614V106.739H80.4468V79.2614H52.9255Z",
    fill: "url(#paint47_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.851 80.3182H80.4468V105.682H105.851V80.3182ZM79.3883 79.2614V106.739H106.91V79.2614H79.3883Z",
    fill: "url(#paint48_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.314 80.3182H106.91V105.682H132.314V80.3182ZM105.851 79.2614V106.739H133.372V79.2614H105.851Z",
    fill: "url(#paint49_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.777 80.3182H133.372V105.682H158.777V80.3182ZM132.314 79.2614V106.739H159.835V79.2614H132.314Z",
    fill: "url(#paint50_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.239 80.3182H159.835V105.682H185.239V80.3182ZM158.777 79.2614V106.739H186.298V79.2614H158.777Z",
    fill: "url(#paint51_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.702 80.3182H186.298V105.682H211.702V80.3182ZM185.239 79.2614V106.739H212.761V79.2614H185.239Z",
    fill: "url(#paint52_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.165 80.3182H212.761V105.682H238.165V80.3182ZM211.702 79.2614V106.739H239.223V79.2614H211.702Z",
    fill: "url(#paint53_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.628 80.3182H239.223V105.682H264.628V80.3182ZM238.165 79.2614V106.739H265.686V79.2614H238.165Z",
    fill: "url(#paint54_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.09 80.3182H265.686V105.682H291.09V80.3182ZM264.628 79.2614V106.739H292.149V79.2614H264.628Z",
    fill: "url(#paint55_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.553 80.3182H292.149V105.682H317.553V80.3182ZM291.09 79.2614V106.739H318.612V79.2614H291.09Z",
    fill: "url(#paint56_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.016 80.3182H318.612V105.682H344.016V80.3182ZM317.553 79.2614V106.739H345.074V79.2614H317.553Z",
    fill: "url(#paint57_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.479 80.3182H345.074V105.682H370.479V80.3182ZM344.016 79.2614V106.739H371.537V79.2614H344.016Z",
    fill: "url(#paint58_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.941 80.3182H371.537V105.682H396.941V80.3182ZM370.479 79.2614V106.739H398V79.2614H370.479Z",
    fill: "url(#paint59_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4628 106.739H1.05851V132.102H26.4628V106.739ZM0 105.682V133.159H27.5213V105.682H0Z",
    fill: "url(#paint60_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9255 106.739H27.5213V132.102H52.9255V106.739ZM26.4628 105.682V133.159H53.984V105.682H26.4628Z",
    fill: "url(#paint61_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3883 106.739H53.984V132.102H79.3883V106.739ZM52.9255 105.682V133.159H80.4468V105.682H52.9255Z",
    fill: "url(#paint62_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.851 106.739H80.4468V132.102H105.851V106.739ZM79.3883 105.682V133.159H106.91V105.682H79.3883Z",
    fill: "url(#paint63_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.314 106.739H106.91V132.102H132.314V106.739ZM105.851 105.682V133.159H133.372V105.682H105.851Z",
    fill: "url(#paint64_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.777 106.739H133.372V132.102H158.777V106.739ZM132.314 105.682V133.159H159.835V105.682H132.314Z",
    fill: "url(#paint65_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.239 106.739H159.835V132.102H185.239V106.739ZM158.777 105.682V133.159H186.298V105.682H158.777Z",
    fill: "url(#paint66_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.702 106.739H186.298V132.102H211.702V106.739ZM185.239 105.682V133.159H212.761V105.682H185.239Z",
    fill: "url(#paint67_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.165 106.739H212.761V132.102H238.165V106.739ZM211.702 105.682V133.159H239.223V105.682H211.702Z",
    fill: "url(#paint68_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.628 106.739H239.223V132.102H264.628V106.739ZM238.165 105.682V133.159H265.686V105.682H238.165Z",
    fill: "url(#paint69_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.09 106.739H265.686V132.102H291.09V106.739ZM264.628 105.682V133.159H292.149V105.682H264.628Z",
    fill: "url(#paint70_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.553 106.739H292.149V132.102H317.553V106.739ZM291.09 105.682V133.159H318.612V105.682H291.09Z",
    fill: "url(#paint71_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.016 106.739H318.612V132.102H344.016V106.739ZM317.553 105.682V133.159H345.074V105.682H317.553Z",
    fill: "url(#paint72_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.479 106.739H345.074V132.102H370.479V106.739ZM344.016 105.682V133.159H371.537V105.682H344.016Z",
    fill: "url(#paint73_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.941 106.739H371.537V132.102H396.941V106.739ZM370.479 105.682V133.159H398V105.682H370.479Z",
    fill: "url(#paint74_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4628 133.159H1.05851V158.523H26.4628V133.159ZM0 132.102V159.58H27.5213V132.102H0Z",
    fill: "url(#paint75_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9255 133.159H27.5213V158.523H52.9255V133.159ZM26.4628 132.102V159.58H53.984V132.102H26.4628Z",
    fill: "url(#paint76_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3883 133.159H53.984V158.523H79.3883V133.159ZM52.9255 132.102V159.58H80.4468V132.102H52.9255Z",
    fill: "url(#paint77_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.851 133.159H80.4468V158.523H105.851V133.159ZM79.3883 132.102V159.58H106.91V132.102H79.3883Z",
    fill: "url(#paint78_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.314 133.159H106.91V158.523H132.314V133.159ZM105.851 132.102V159.58H133.372V132.102H105.851Z",
    fill: "url(#paint79_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.777 133.159H133.372V158.523H158.777V133.159ZM132.314 132.102V159.58H159.835V132.102H132.314Z",
    fill: "url(#paint80_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.239 133.159H159.835V158.523H185.239V133.159ZM158.777 132.102V159.58H186.298V132.102H158.777Z",
    fill: "url(#paint81_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.702 133.159H186.298V158.523H211.702V133.159ZM185.239 132.102V159.58H212.761V132.102H185.239Z",
    fill: "url(#paint82_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.165 133.159H212.761V158.523H238.165V133.159ZM211.702 132.102V159.58H239.223V132.102H211.702Z",
    fill: "url(#paint83_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.628 133.159H239.223V158.523H264.628V133.159ZM238.165 132.102V159.58H265.686V132.102H238.165Z",
    fill: "url(#paint84_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.09 133.159H265.686V158.523H291.09V133.159ZM264.628 132.102V159.58H292.149V132.102H264.628Z",
    fill: "url(#paint85_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.553 133.159H292.149V158.523H317.553V133.159ZM291.09 132.102V159.58H318.612V132.102H291.09Z",
    fill: "url(#paint86_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.016 133.159H318.612V158.523H344.016V133.159ZM317.553 132.102V159.58H345.074V132.102H317.553Z",
    fill: "url(#paint87_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.479 133.159H345.074V158.523H370.479V133.159ZM344.016 132.102V159.58H371.537V132.102H344.016Z",
    fill: "url(#paint88_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.941 133.159H371.537V158.523H396.941V133.159ZM370.479 132.102V159.58H398V132.102H370.479Z",
    fill: "url(#paint89_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4628 159.58H1.05851V184.943H26.4628V159.58ZM0 158.523V186H27.5213V158.523H0Z",
    fill: "url(#paint90_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9255 159.58H27.5213V184.943H52.9255V159.58ZM26.4628 158.523V186H53.984V158.523H26.4628Z",
    fill: "url(#paint91_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3883 159.58H53.984V184.943H79.3883V159.58ZM52.9255 158.523V186H80.4468V158.523H52.9255Z",
    fill: "url(#paint92_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.851 159.58H80.4468V184.943H105.851V159.58ZM79.3883 158.523V186H106.91V158.523H79.3883Z",
    fill: "url(#paint93_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.314 159.58H106.91V184.943H132.314V159.58ZM105.851 158.523V186H133.372V158.523H105.851Z",
    fill: "url(#paint94_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.777 159.58H133.372V184.943H158.777V159.58ZM132.314 158.523V186H159.835V158.523H132.314Z",
    fill: "url(#paint95_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.239 159.58H159.835V184.943H185.239V159.58ZM158.777 158.523V186H186.298V158.523H158.777Z",
    fill: "url(#paint96_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.702 159.58H186.298V184.943H211.702V159.58ZM185.239 158.523V186H212.761V158.523H185.239Z",
    fill: "url(#paint97_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.165 159.58H212.761V184.943H238.165V159.58ZM211.702 158.523V186H239.223V158.523H211.702Z",
    fill: "url(#paint98_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.628 159.58H239.223V184.943H264.628V159.58ZM238.165 158.523V186H265.686V158.523H238.165Z",
    fill: "url(#paint99_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.09 159.58H265.686V184.943H291.09V159.58ZM264.628 158.523V186H292.149V158.523H264.628Z",
    fill: "url(#paint100_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.553 159.58H292.149V184.943H317.553V159.58ZM291.09 158.523V186H318.612V158.523H291.09Z",
    fill: "url(#paint101_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.016 159.58H318.612V184.943H344.016V159.58ZM317.553 158.523V186H345.074V158.523H317.553Z",
    fill: "url(#paint102_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.479 159.58H345.074V184.943H370.479V159.58ZM344.016 158.523V186H371.537V158.523H344.016Z",
    fill: "url(#paint103_radial_33392_15576)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.941 159.58H371.537V184.943H396.941V159.58ZM370.479 158.523V186H398V158.523H370.479Z",
    fill: "url(#paint104_radial_33392_15576)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_33392_15576",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199 3.5) rotate(90) scale(147.5 190.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-3)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-3)",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUploadBackground);
export default __webpack_public_path__ + "static/media/videoUploadBackground.14685b312a432d76f6ce515eef1fe1d5.svg";
export { ForwardRef as ReactComponent };